import React from "react"
import Modal from "../shared/Modal"
import CustomButton from "../shared/CustomButton"
import { CloseMD, prefix } from "../normalizer"

const tModal = prefix('gamification2026.register')

const TermsAndConditionsModal = ({
  selected,
  terms,
  onNoAcceptTermsModal,
  onAcceptTermsModal
}) => {

  const handleNoAcceptAction = e => {
    e.preventDefault()
    onNoAcceptTermsModal()
  }

  const handleAcceptAction = e => {
    e.preventDefault()
    onAcceptTermsModal()
  }

  return (
    <Modal show={selected} large>
      <div className="register-terms-modal">
        <div className="register-terms-modal__header">
          <h4 className="register-terms-modal__title">{tModal('terms-modal-title')}</h4>
          <button
            type="button"
            className="register-terms-modal__close"
            onClick={onNoAcceptTermsModal}
            aria-label={tModal('terms-modal-reject')}
          >
            <CloseMD />
          </button>
        </div>
        <div
          className="register-terms-modal__content"
          dangerouslySetInnerHTML={{ __html: terms }}
        />
        <div className="register-terms-modal__actions">
          <CustomButton type="button" secondary onClick={handleNoAcceptAction}>
            {tModal('terms-modal-reject')}
          </CustomButton>
          <CustomButton type="button" onClick={handleAcceptAction}>
            {tModal('terms-modal-accept')}
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default TermsAndConditionsModal
